<template>
    <div>
        <!-- <el-form :inline="true" class="user-search">
            <el-form-item label="分组">
                <el-select v-model="pageparm.type" placeholder="请选择">
                    <el-option v-for="item in typeArr" :key="item.value" :label="item.key" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="selectSlideshow()">查询</el-button>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form> -->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column prop="id" label="ID"> </el-table-column>
            <el-table-column prop="gameName" :align="'center'" sortable label="游戏名"> </el-table-column>
            <el-table-column prop="gameTypeName" :align="'center'" sortable label="游戏类型名"> </el-table-column>
            <el-table-column prop="imageUrl" :align="'center'" sortable label="用户头像">
                <template slot-scope="scope">
                    <img v-if="scope.row.imageUrl" style="width: 90px;height: 90px;" :src="scope.row.imageUrl" />
                    <div v-if="scope.row.imageUrl == null">暂无用户头像</div>
                </template>
            </el-table-column>
            <el-table-column prop="nickName" :align="'center'" sortable label="用户昵称"> </el-table-column>
            <el-table-column prop="swmopsis" sortable label="评论主题"> </el-table-column>
            <el-table-column prop="comments" :align="'center'" sortable label="评论内容"> </el-table-column>
            <el-table-column prop="star" :align="'center'" sortable label="评分"> </el-table-column>
            <el-table-column prop="status" :align="'center'" sortable label="评论状态">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status == 0">好评</el-tag>
                    <el-tag type="" v-if="scope.row.status == 1">中评</el-tag>
                    <el-tag type="danger" v-if="scope.row.status == 2">差评</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="url" :align="'center'" label="评论图片">
                <template slot-scope="scope">
                    <div v-for="item, index in fanhuiArr(scope.row.url)">
                        <el-image style="height:100px" :src="item" :fit="`fill`" :preview-src-list="[item]">
                        </el-image>
                    </div>

                </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteSlideshow(scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
import { userCommentsList } from "../../../api/userMG";
import Pagination from "../../../components/Pagination.vue";
export default {
    // 注册组件
    components: {
        Pagination
    },
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10,
                type: ""
            },
            listData: [], //
            loading:false,
        }
    },
    created() {
        this.getUserGoodsList();
    },
    methods: {
        getUserGoodsList() {
            this.loading = true;
            let obj = {
                page: (this.pageparm.currentPage - 1) * 20,
                userId: this.id,
                // userId: 148,
            }
            userCommentsList(obj).then(res => {
                this.loading = false;
                if (res.code == 200) {
                    this.listData = res.data.data;
                    // return;
                }
            })

        },
        fanhuiArr(url) {
            // url.split(",")
            // let arr = url.split("','"); // ["Hello", " World!"]
            let arr = JSON.parse(url); // ["Hello", " World!"]
            return arr
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/user/components/userComments.vue